export const companyConfig = {
  brandName:
    process.env.REACT_APP_BRAND_NAME || "Eduvic.com.au",

tradingNames:
    process.env.REACT_APP_TRADING_NAMES || "",

  legalEntityName:
    process.env.REACT_APP_LEGAL_ENTITY_NAME || "",

  abn:
    process.env.REACT_APP_COMPANY_ABN || "",

  acn:
    process.env.REACT_APP_COMPANY_ACN || "",

// Add to companyConfig:
address: process.env.REACT_APP_COMPANY_ADDRESS || "Melbourne, Victoria, Australia",
supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "support@eduvic.com.au",
website: process.env.REACT_APP_WEBSITE || "https://eduvic.com.au",
effectiveDate: process.env.REACT_APP_EFFECTIVE_DATE || "1 August 2025",

  get legalIdentifier() {
    const identifiers = [];

    if (this.acn) {
      identifiers.push(`ACN ${this.acn}`);
    }

    if (this.abn) {
      identifiers.push(`ABN ${this.abn}`);
    }

    return identifiers.join(", ");
  },

  get operatorDescription() {
    const identifier =
      this.legalIdentifier.length > 0
        ? ` (${this.legalIdentifier})`
        : "";

    return `${this.legalEntityName}${identifier}`;
  },
};